import { Button } from '@/components/ui/button';
import { Tooltip, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { SMALL_IMAGE_WIDTH } from '@/lib/utils';
import { OctagonAlertIcon, PencilIcon } from 'lucide-react';

interface ImageEditTooltipProps {
    isHovering: boolean;
    isResizing?: boolean;
    hasAlt: boolean;
    width: number;
    refreshImageProperties: () => void;
    setIsOpen: (open: boolean) => void;
    editDisabled?: boolean;
}

export function ImageEditTooltip({
    isHovering,
    isResizing = false,
    hasAlt,
    width,
    refreshImageProperties,
    setIsOpen,
    editDisabled = false,
}: ImageEditTooltipProps) {
    if (isResizing) {
        return null;
    }
    const isSmallImage = width && width < SMALL_IMAGE_WIDTH;
    const controlPositionClass = isSmallImage ? 'left-full' : 'right-0';

    return (
        <>
            {isHovering && !editDisabled && (
                <div
                    className={`absolute top-0 ${controlPositionClass} border border-gray-300 z-10 max-w-100 bg-gray-100 rounded-md flex items-center`}
                >
                    <div className="flex items-center w-full">
                        <TooltipProvider delayDuration={100}>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button
                                        variant="ghost"
                                        size="icon"
                                        className="cursor-pointer hover:bg-gray-300"
                                        onClick={() => {
                                            refreshImageProperties();
                                            setIsOpen(true);
                                        }}
                                    >
                                        <PencilIcon className="size-5" />
                                    </Button>
                                </TooltipTrigger>
                            </Tooltip>
                        </TooltipProvider>
                    </div>
                </div>
            )}
            {!isHovering && !hasAlt && (
                <div
                    className={`absolute top-0 ${controlPositionClass} border border-red-500 z-10 bg-gray-100 rounded-md flex items-center p-1`}
                >
                    <OctagonAlertIcon className="size-8 text-red-500" />
                </div>
            )}
        </>
    );
}
